// import { PdfUploader } from "../components";

const transBase64Field = files => {
  return files;

  // TODO，目前專案沒有用到，之後若有使用 PdfUploader 元件，則需要將 base64 轉為 url
  // return files.map(file => ({
  //   ...file,
  //   url: file[PdfUploader.BASE64_FIELD_NAME] ? file[PdfUploader.BASE64_FIELD_NAME] : file.url
  // }));
};

export const form = {
  collectOriginalAndNewFiles(fileList) {
    let oriFiles = [],
      newFiles = [],
      filePriorities = [];
    if (fileList && fileList.length) {
      fileList.forEach(file => {
        // antd Upload 元件上傳的檔案會以 rc-upload-xxx 為 uid 開頭
        if (file.isUpload || (file && file.uid?.toString().startsWith("rc-upload"))) {
          newFiles.push(file);
        } else {
          oriFiles.push(file.uid);
        }
      });

      // 照片排序
      filePriorities = fileList.map(file => file.uid);
      // 後端透過 file 的 id 屬性識別排序依據
      newFiles = newFiles.map(file => ({ ...file, id: file.uid.toString() }));
    }
    return [oriFiles, transBase64Field(newFiles), filePriorities];
  }
};
